import Error from 'pages/Error';
import { Route, Routes } from 'react-router-dom';

import SetPassword from './SetPassword';
import StartNow from './StartNow';
import Welcome from './Welcome';

const ROUTES = [
  {
    path: '*',
    element: () => <Welcome />,
  },
  {
    path: '/set-password',
    element: () => <SetPassword />,
  },
  {
    path: '/start-now',
    element: () => <StartNow />,
  },
];

const Invited = () => (
  <Routes>
    {ROUTES.map(({ path, element }) => (
      <Route key={Math.random()} path={path} element={element()} />
    ))}
    <Route path="*" element={<Error />} />
  </Routes>
);

export default Invited;
